import { useTranslation } from 'react-i18next';
import { SelectItemSearchModal } from '@/core/SelectItemSearchModal.molecule';
import { sqWorkbookStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { SeeqNames } from '@/main/app.constants.seeqnames';
import { Button } from '@seeqdev/qomponents';
import type { SelectedSearchItem } from '@/search/search.types';

export interface CreateApplyInScalingTableModalProps {
  header: string;
  helpText: string;
  onClose: () => void;
  onSubmit: () => void;
  onCreateNewItem: () => void;
  onSelectItem: (item: SelectedSearchItem) => void;
  selectedItem: SelectedSearchItem | undefined;
  iconPartialTooltipKey: string;
}

export const CreateApplyInScalingTableModal = (props: CreateApplyInScalingTableModalProps) => {
  const { header, helpText, onClose, onSubmit, onCreateNewItem, onSelectItem, selectedItem, iconPartialTooltipKey } =
    props;
  const { t } = useTranslation();
  const workbookId = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.workbookId);

  const isValidScalingTable = (item: any): Promise<boolean> => {
    return Promise.resolve(item.type === SeeqNames.Types.TableDefinition);
  };

  const footer = (
    <div className="flexColumnContainer flexJustifyEnd p10">
      <Button onClick={onClose} label={t('CANCEL')} extraClassNames="mr20" testId="cancelSelectScalingTable" />
      <Button
        onClick={onSubmit}
        label={t('SAVE')}
        variant="theme"
        testId="saveSelectScalingTable"
        disabled={!selectedItem}
      />
    </div>
  );

  const body = (
    <div className="alert alert-info" data-testid="selectScalingTableHelpText">
      {t(helpText)}
    </div>
  );

  return (
    <>
      <SelectItemSearchModal
        onClose={onClose}
        iconPartialTooltipKey={iconPartialTooltipKey}
        onSelect={onSelectItem}
        selectItems={selectedItem?.id ? [selectedItem] : undefined}
        validateItem={isValidScalingTable}
        scopeIds={[workbookId]}
        excludeGloballyScoped={false}
        body={body}
        header={{ title: t(header) }}
        footer={footer}
        testId="selectScalingTableModal"
        searchTypes={[SeeqNames.Types.TableDefinition]}
        showCreateNewItem={true}
        onCreateNewItem={onCreateNewItem}
        createNewItemLabel="MODELS.CREATE_SCALING_TABLE"
        createNewItemMessage="MODELS.SCALING_TABLE_NOT_FOUND"
        itemTypeToShowInOverview="scaling-tables"
        overviewLabel="SEARCH_DATA.SCALING"
        doNotDisableOnEdit={true}
      />
    </>
  );
};
